import { render, staticRenderFns } from "./IolResultHeader.vue?vue&type=template&id=d54ea10c"
import script from "./IolResultHeader.vue?vue&type=script&lang=js"
export * from "./IolResultHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports